import React from "react";
import { Modal, Input, Form } from "antd";
function AddBills({ isShow, setIsShow }) {
    const handleCancel = () => setIsShow(false);
    return (
        <div className="modalBox ">
            <Modal
                title="Thông tin xuất hóa đơn"
                className="BillsModal modalStyle"
                visible={isShow}
                onCancel={handleCancel}
                footer={null}
            >
                <Form>
                    <Form.Item className="formInput "
                        label="Thông tin xuất hóa đơn"
                        name="companyName"
                    >
                        <Input placeholder="Nhập tên công ty" />
                    </Form.Item>
                    <Form.Item className="formInput "
                        label="Địa chỉ công ty"
                        name="address"
                    >
                        <Input placeholder="Nhập địa chỉ công ty" />
                    </Form.Item>
                    <Form.Item className="formInput "
                        label="Mã số thuế"
                        name="VatCode"
                    >
                        <Input placeholder="Nhập mã số thuế" />
                    </Form.Item>
                    <Form.Item className="btnModal">
                        <button className="btnStyle" >
                            Complete
                        </button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}
export default AddBills;
